var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeaq2LogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229 620 c-65 -34 -99 -143 -65 -208 39 -74 115 -107 190 -82 53 17 91 53 151 144 59 90 94 116 153 116 31 0 47 -7 70 -30 47 -47 48 -110 2 -160 -24 -26 -35 -30 -79 -30 -59 0 -59 5 -3 83 l34 47 -30 0 c-25 0 -35 -9 -70 -62 -47 -71 -44 -89 14 -108 137 -46 259 93 195 222 -28 57 -63 81 -125 85 -85 7 -122 -23 -236 -186 -42 -60 -75 -81 -130 -81 -33 0 -48 6 -71 29 -24 25 -29 38 -29 79 0 41 5 54 30 81 26 27 37 31 80 31 28 0 50 -3 50 -7 0 -4 -18 -33 -40 -64 -36 -52 -38 -57 -20 -62 24 -6 39 6 79 65 41 62 40 85 -4 104 -47 19 -103 17 -146 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaq2LogoWhite);
export default __webpack_public_path__ + "static/media/peaq2_logo_white.0267b57aa5576d3cdb2ff46b59e0234f.svg";
export { ForwardRef as ReactComponent };